<template>
  <div class="imageSelectionDiv">
    <v-icon v-show="imageLoaded" class="viewIcon" color="white" @click="openPreview">
      visibility
    </v-icon>
    <ImagePreview ref="imagePreview"
                  :favorite-editable="favoriteEditable"
                  :filter="filter"
                  :image="image"
                  :show-favorite-icon="showFavoriteIcon"
                  :small-height="smallHeight"
                  :small-width="smallWidth"
                  class="imagePreview"
                  doNotOpenOnClick
                  @select_image="onSelect()"
                  @small-loaded="imageLoaded = true"
    />
  </div>
</template>

<script lang="ts">
import Component from 'vue-class-component'
import BasicComponent from "@/global/BasicComponent";
import {Prop} from "vue-property-decorator";
import {ImageDto, ImageFilterDto} from "@swagger";
import ImagePreview from "@/components/ImagePreview.vue";

@Component({
  components: {ImagePreview}
})
export default class ManuallyExpandableImagePreview extends BasicComponent {

  @Prop(Object) image: ImageDto;
  @Prop(String) filter: ImageFilterDto;
  /**
   * The component allows to toggle the favorite state
   */
  @Prop({
    type: Boolean,
    default: false
  }) readonly favoriteEditable: boolean;
  @Prop({
    type: Boolean,
    default: true
  }) readonly showFavoriteIcon: boolean;
  @Prop(String) readonly smallHeight: string;
  @Prop(String) readonly smallWidth: string;

  imageLoaded: boolean = false;

  openPreview() {
    const ref: ImagePreview = this.$refs.imagePreview as ImagePreview;
    if (!ref) return;
    ref.openDialog();
  }

  onSelect() {
    this.$emit("select");
  }

}

</script>
<style lang="scss" scoped>
.imageSelectionDiv {
  position: relative;
  display: inline-block;

  .viewIcon {
    color: rgba(255, 255, 255, 0.75) !important;
    position: absolute;
    top: 6px;
    right: 6px;
    z-index: 10;

    &:hover {
      color: white !important;
    }
  }
}
</style>
<style lang="scss">

</style>